import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect, useState } from "react";

const Index = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-poppins">
      <Navbar />
      
      <main className="flex-grow flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center max-w-3xl mx-auto">
          <h1 
            className="text-3xl sm:text-5xl font-medium text-foreground mb-4 mt-24 opacity-0 animate-fade-in"
            style={{ animationDelay: "400ms" }}
          >
            Seamless Multi-language Translation iOS App
          </h1>
          
          <p 
            className="text-base sm:text-xl font-light text-muted-foreground mb-8 leading-relaxed opacity-0 animate-fade-in"
            style={{ animationDelay: "600ms" }}
          >
            Translate Anything Into Multiple Languages Seamlessly
          </p>
          
          <div 
            className="space-y-3 opacity-0 animate-fade-in mb-12"
            style={{ animationDelay: "800ms" }}
          >
            <Button 
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-base sm:text-lg"
              onClick={() => window.open('https://apps.apple.com/app/id1641482851', '_blank')}
            >
              Download
            </Button>
            <div className="space-y-1">
              <p className="text-xs sm:text-sm text-muted-foreground">190+ languages supported</p>
            </div>
          </div>

          <div 
            className="transform transition-all duration-1000 ease-out" 
            style={{ 
              transform: `scale(${1 + scrollPosition * 0.0004})`,
              maxWidth: "100%",
              margin: "0 auto"
            }}
          >
            <img
              src="/lovable-uploads/9facc941-1ade-4619-8b3e-4ed1514612a1.png"
              alt="VTranslate App Screenshot"
              className="w-96 h-auto mx-auto"
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Index;